import type { IDomainEventBus } from '../../../application/port/out/IDomainEventBus'
import type { DomainEvent } from '../../../domain/events/DomainEvent'

type Handler<T extends DomainEvent = DomainEvent> = (event: T) => void | Promise<void>

// Simple in-memory event bus. Handlers are registered at startup (container.ts).
// For cross-service or persistent event dispatch, swap this for an adapter
// that publishes to the IEventBus (QStash / Supabase outbox).
export class InMemoryDomainEventBus implements IDomainEventBus {
  private handlers = new Map<string, Handler[]>()

  on<T extends DomainEvent>(eventType: string, handler: Handler<T>): void {
    const existing = this.handlers.get(eventType) ?? []
    this.handlers.set(eventType, [...existing, handler as Handler])
  }

  async dispatch(events: DomainEvent[]): Promise<void> {
    for (const event of events) {
      const handlers = this.handlers.get(event.eventType) ?? []
      for (const handler of handlers) {
        await handler(event)
      }
      console.debug(`[DomainEvent] ${event.eventType}`, { id: event.aggregateId, at: event.occurredAt })
    }
  }
}
